import { useSetPageTitle } from "../../hooks/useSetPageTitle";
import { AppLayout } from "../../components/layout/app-layout";
import SurveysTab from "./tabs/surveys.tab";
import { useNavigate, useParams } from "react-router-dom";
import CreateSurvey from "../create-survey/create-survey";
import SurveyResultsPage from "../survey-results/survey-results.page";
import PanelsTab from "./tabs/panels.tab";
import CombineSurveysPage from "./combine-surveys/combine-surveys-page";
import SurveysBetaTab from "./beta/surveys-beta.tab";
import SurveysBetaEditPage from "./beta/edit/surveys-beta-edit.page";
import PulseTab from "./pulse/pulse.tab";
import PulseCreateTab from "./pulse/pulse-create.tab";
import PulseDetailTab from "./pulse/pulse-detail.tab";

const SurveysPage = () => {

  useSetPageTitle('Surveys');
  const navigate = useNavigate();
  const { clientId } = useParams<{ clientId?: string }>();

  const surveysTabs = [
    { id: '', key: 'ALL', label: 'Surveys' },
    { id: 'beta', key: 'ALL', label: 'Surveys (Beta)' },
    { id: 'pulse', key: 'ALL', label: 'Pulse' },
    { id: 'panels', key: 'panels', label: 'Panels' },
    // { id: 'results', key: 'results', label: 'Results' },
    { id: 'overview', key: 'NEVER', label: 'Overview' },
    // { id: 'analytics', key: 'analytics', label: 'Analytics' },
    // { id: 'templates', key: 'templates', label: 'Templates' },
    // { id: 'generate-survey', key: 'generate_survey', label: 'Generate Survey' },
    { id: 'view', key: 'NEVER', label: 'View Survey' },
    { id: 'create', key: 'NEVER', label: 'Create Survey' },
    { id: 'beta-create', key: 'NEVER', label: 'Edit survey (Beta)' },
    { id: 'combine', key: 'NEVER', label: 'Combine surveys' },
    { id: 'pulse-create', key: 'NEVER', label: 'New pulse' },
    { id: 'pulse-detail', key: 'NEVER', label: 'Pulse detail' },
  ];

  const { tab } = useParams<{ tab?: string }>();

  const validTabs = surveysTabs.map(tab => tab.id);
  type TabType = typeof validTabs[number];

  const currentTab: TabType = validTabs.includes(tab as TabType)
    ? (tab as TabType)
    : '';

  const handleTabChange = (tabId: string) => {
    if (clientId) {
      navigate(`/client/${clientId}/surveys/${tabId}`);
    } else {
      navigate(`/surveys/${tabId}`);
    }
  };

  // New layout for org admins and regular users
  return (
    <AppLayout
      activePage="/surveys"
      navbarProps={{
        showBackButton: false,
        backPath: "/surveys",
        tabs: surveysTabs,
        activeTab: currentTab === 'pulse-create' || currentTab === 'pulse-detail' ? 'pulse' : currentTab,
        onTabChange: handleTabChange,
      }}
    >
      <div className="space-y-6">
        {currentTab === '' && (
          <SurveysTab />
        )}
        {currentTab === 'beta' && (
          <SurveysBetaTab />
        )}
        {currentTab === 'combine' && (
          <div className="w-full min-w-0">
            <CombineSurveysPage />
          </div>
        )}
        {currentTab === 'pulse' && (
          <PulseTab />
        )}
        {currentTab === 'pulse-create' && (
          <PulseCreateTab />
        )}
        {currentTab === 'pulse-detail' && (
          <PulseDetailTab />
        )}
        {currentTab === 'panels' && (
          <PanelsTab />
        )}
        {currentTab === 'view' && (
          <SurveyResultsPage />
        )}
        {currentTab === 'create' && (
          <CreateSurvey />
        )}
        {currentTab === 'beta-create' && (
          <SurveysBetaEditPage />
        )}
      </div>
    </AppLayout>
  );
};

export default SurveysPage;
